import styles from "./CookieConsentDeclineButton.module.css";

export default function CookieConsentDeclineButton(): JSX.Element {
  return (
    <div
      data-icon-only="No"
      data-icon="No"
      data-size="Medium"
      data-state="Default"
      data-type="Secondary"
      className={styles.button}
    >
      <div className={styles.text}>Decline</div>
    </div>
  );
}
